var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveForward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.91747C5.92292 2.91747 1 7.63263 1 13.4532C1 19.2841 5.92215 24 12 24C18.0771 24 23 19.2848 23 13.4642C23 11.3017 22.3145 9.28402 21.1481 7.60822C20.8312 7.1529 20.1889 7.02987 19.7135 7.33341C19.2382 7.63695 19.1097 8.25212 19.4266 8.70744C20.3751 10.0702 20.931 11.7076 20.931 13.4642C20.931 18.1904 16.9344 22.0184 12 22.0184C7.06636 22.0184 3.06897 18.1912 3.06897 13.4532C3.06897 8.72706 7.06558 4.89912 12 4.89912C13.1054 4.89912 14.1088 5.06859 15.0256 5.33102C16.595 5.78025 17.0058 5.80007 17.5 5.45455C17.9942 5.10902 17.9192 4.50362 17.5823 4.06163L14.2057 0.340291C13.8306 -0.0724545 13.1772 -0.115791 12.7463 0.243497C12.3153 0.602784 12.2701 1.22864 12.6452 1.64139L13.9382 3.06408C13.3247 2.97074 12.679 2.91747 12 2.91747Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11H13.0689C13.0274 11 12.9902 11.0256 12.9755 11.0644L12.2039 13.0914C12.179 13.1568 12.2272 13.227 12.2973 13.227C12.8611 13.227 13.5807 13.227 14.5 13.227C15.5 13.227 16.0139 13.8706 16 14.6364C15.9863 15.3894 15.5 16 14.5 16C13.5 16 12 16 12 16",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16V11.2261C9.5 11.1392 9.39697 11.0937 9.33273 11.1521L8 12.3636",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveForward);
export default __webpack_public_path__ + "static/media/move-forward.0a15a70c5bb322285bfc99907d158e6f.svg";
export { ForwardRef as ReactComponent };